import {nextTick} from 'vue';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import {disableHtmlScrollMixin} from '../mixins/component-mixins';
import {globalActions} from '../../store/global-actions';
import TimeMe from 'timeme.js';
import {Cookies} from '../../shared/cookies-extended';
import {store} from '../../store/global-store';
import _u from '../../shared/utils';
import VueMultiselectExtended from '../inputs/multiselect';
import $ from 'jquery'; // TODO: refactor and remove usage of jquery
import getCountries from '../../shared/countries/countries.js';

const modalWithConfirmationTemplateName = '#modal-with-confirmation';
const modalQuestionTemplateName = '#modal-question';

const modal = {
    props: {
        isActive: {},
        header: {},
        body: {},
        autoClose: {},
        emptyFooter: {},
        closeOnCross: {},
        onClose: {},
        trackAction: {},
        trackCategory: {},
        preventShowModals: { default: false },
        placeButtonsInColumn: { default: false },
        noHeader: { default: false },
    },
    mixins: [disableHtmlScrollMixin],
    data() {
        return {
            active: this.isActive,
            disableBodyScroll: this.isActive,
            activeId: null,
        };
    },
    watch: {
        isActive(value) {
            const needClose = this.active && !value;
            this.active = value;

            if (needClose) {
                this.close();
            }
        },
        active(value) {
            value ? this.beforeOpen() : this.beforeClose();
            this._setDisableBodyScroll(value);
            if (this.preventShowModals) {
                this._setPreventShowModalsState(value);
            }
        },
    },
    computed: {
        isTop() {
            return this.activeId === store.state.shared.modalsCount;
        },
    },
    methods: {
        open() {
            this.active = true;
        },
        close(data) {
            if (this.onClose) {
                this.onClose();
            }
            this.active = false;
            this.$emit('close', data);
            this.$emit('update:isActive', false);
        },
        beforeOpen() {
            store.commit('incrementModalsCount');
            this.activeId = store.state.shared.modalsCount;
        },
        beforeClose() {
            if (store.state.shared.modalsCount > 0) {
                store.commit('decrementModalsCount');
            }
            this.activeId = null;
        },
        clickOutside(e) {
            if (this.autoClose && e.target === e.currentTarget) {
                this.close();
            }
        },
        hasSlot(name) {
            return !!this.$slots[name];
        },
        _getDisableScrollEl() {
            return this.$el;
        },
        _setDisableBodyScroll(value) {
            if (value) {
                nextTick(() => {
                    this.disableBodyScroll = value;
                });
            } else {
                this.disableBodyScroll = value;
            }
        },
        _setPreventShowModalsState(value) {
            store.commit('preventShowModals', value);
        },
    },
    created() {
        if (this.autoClose) {
            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 27) {
                    this.close();
                }
            });
        }
    },
    mounted() {
        if (this.isActive) {
            this.beforeOpen();
        }
    },
};

const questionModal = {
    props: {
        cancelText: {},
        acceptText: {},
        acceptAction: {},
        cancelAction: {},
    },
    data() {
        return {
            acceptFunc: this.acceptAction,
            cancelFunc: this.cancelAction,
            cancellButtonId: '',
        };
    },
    methods: {
        open(acceptAction, cancelAction) {
            this.acceptFunc = acceptAction || this.acceptFunc;
            this.cancelFunc = cancelAction || this.cancelFunc;
            this.active = true;
        },
        cancel() {
            if (this.cancelFunc) {
                this.cancelFunc();
            }

            this.close();
        },
        accept() {
            if (this.acceptFunc) {
                this.acceptFunc();
            }

            this.close();
        },
    },
};

const userModalMixin = {
    inheritAttrs: false,
    components: {
        Multiselect: VueMultiselectExtended,
    },
    props: {
        agreementMessage: {type: String},
        reasons: {type: Array},
        otherReason: {type: Number},
        confirmText: {type: String},
        isConfirmTextRequired: {
            type: Boolean,
            default: true,
        },
        isReasonRequired: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            confirmTextEntered: '',
            selectedReason: null,
            selectedReasonMessage: null,
        };
    },
    computed: {
        selectedReasonId() {
            return this.selectedReason ? this.selectedReason.value : null;
        },
        isButtonDisabled() {
            return this.isSubmitDisabled;
        },
        isOtherReasonSelected() {
            return this.selectedReason && this.selectedReason.value === this.otherReason;
        },
        isReasonMessageEmpty() {
            return this.selectedReasonMessage == null || this.selectedReasonMessage === '' || /^\s+$/.test(this.selectedReasonMessage);
        },
        isSubmitDisabled() {
            return this._isConfirmTextInvalid || this._isReasonInvalid;
        },
        isReasonSelected() {
            return this.selectedReason;
        },
        _isConfirmTextInvalid() {
            return (this.isConfirmTextRequired && this.confirmText !== this.confirmTextEntered);
        },
        _isReasonInvalid() {
            return this.isOtherReasonSelected && this.isReasonMessageEmpty;
        },
    },
};

const modalWithConfirmation = {
    extends: modal,
    template: modalWithConfirmationTemplateName,
    mixins: [questionModal, userModalMixin],
    props: {
        url: {},
        labels: {},
        trackAction: {},
        trackCategory: {},
    },
    data() {
        return {
            selectedReason: null,
            selectedReasonMessage: null,
            targetId: null,
        };
    },
    watch: {
        selectedReason(val) {
            if (val) {
                nextTick(() => {
                    VueScrollTo.scrollTo(this.$refs.confirmRegion, 500, {container: this.$el.getElementsByClassName('modal__body')[0]});
                });
            }
        },
    },
    methods: {
        accept() {
            this._sendRequest(this.url);
            this.clearModal();
            this.close();
            this.$emit('confirmed');
        },
        successfullySent() {
            globalActions.openInfoModal(this.labels.successHeader, this.labels.successMessage);
        },
        clearModal() {
            this.selectedReason = null;
            this.selectedReasonMessage = null;
            this.targetId = null;
            this.confirmTextEntered = null;
        },
        _sendRequest(url) {
            if (this.isReasonSelected) {
                axios.post(url,
                    this.getRequestBody(),
                ).then((response) => {
                    this.successfullySent(response.data);
                }).catch((error) => {
                    if (error.response.status === 403) {
                        globalActions.openInfoModal(this.labels.alreadySentHeader, this.labels.alreadySentMessage);
                    } else {
                        globalActions.openInfoModal(this.labels.errorTitle, this.labels.errorMessage);
                    }
                });
            } else if (!this.isReasonRequired) {
                this.successfullySent();
            }
        },
    },
};

const deleteModal = {
    extends: modalWithConfirmation,
    methods: {
        getRequestBody() {
            return {
                reason: this.selectedReason.value,
                reasonMessage: this.selectedReasonMessage,
                isReadyToDelete: true,
            };
        },
    },
};

const reportModal = {
    extends: modalWithConfirmation,
    props: {
        reportType: {required: true},
    },
    methods: {
        initializeReportModalData(payload) {
            this.active = true;
            this.targetId = payload.targetId;
        },
        getRequestBody() {
            return {
                targetId: this.targetId,
                reason: this.selectedReason.value,
                reasonMessage: this.selectedReasonMessage,
            };
        },
        _subscribeOpen() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openReportModal' && this.reportType === mutation.payload.reportType) {
                    this.initializeReportModalData(mutation.payload);
                }
            });
        },
    },
    mounted() {
        this._subscribeOpen();
    },
};

const baseEngageModal = {
    data() {
        return {
            openOnlyIfTargetVisible: true,
            scrollToTarget: false,
        };
    },
    props: {
        timeoutSec: {
            type: Number,
        },
        cookie: {
            type: String,
        },
        cookieExpiration: {
            type: Number,
            default: 365 * 1000,
        },
        engageAction: {
            type: String,
        },
    },
    methods: {
        defaultOpen() {
            if (isAnyModalOpened()) {
                return false;
            }

            if (!this.isEngageInsideActiveModalOrRoot()) {
                // do not show if modal is opened and engage not inside, open when engage is in active modal or root
                return false;
            }

            if (this.openOnlyIfTargetVisible && !_u.isFullVisibilityExpected(this.$el, true)) {
                return false;
            }

            this.active = true;

            if (this.scrollToTarget) {
                this.$el.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
            }
            return true;
        },
        defaultClose(data) {
            this.active = false;
            this.$emit('close', data);
            this.$emit('update:isActive', false);
        },
        beforeOpen() {
            store.commit('incrementEngagesCount');
        },
        beforeClose() {
            if (store.state.shared.engagesCount > 0) {
                store.commit('decrementEngagesCount');
            }
        },
        isEngageInsideActiveModalOrRoot() {
            try {
                let parentComponent = this.$parent;

                while (parentComponent) {
                    if (parentComponent.$options._componentTag === 'modal' ||
                        parentComponent.$options._componentTag === 'modal-fullscreen') {
                        return parentComponent.active;
                    }

                    parentComponent = parentComponent.$parent;
                }
            } catch (error) {
                console.error(error);
            }

            return true;
        },
    },
    watch: {
        active(value) {
            value ? this.beforeOpen() : this.beforeClose();
        },
    },
};

const timerBasedModal = {
    mixins: [baseEngageModal],
    data() {
        return {
            storageKey: 'modal',
            cookieKey: 'Modal-Temporary-Disabled',
            temporaryDisableTimeout: 30,
        };
    },
    props: {
        isPopUpDisabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        open() {
            if (this.isPopUpDisabled) {
                return false;
            }
            if (this.isModalTemporaryDisabled()) {
                return false;
            }
            return this.defaultOpen();
        },
        close(data) {
            this.defaultClose(data);
            this.temporaryDisableModals();
        },
        async tryOpenModal() {
            const cookie = await Cookies.getWithBackupCheckAsync(this.cookie);

            if (!cookie) {
                this.open();

                if (this.active) {
                    this.temporaryDisableModals();
                    await Cookies.setWithBackupAsync(this.cookie, true, {expires: this.cookieExpiration});
                    this.removeDelayedModal();
                } else {
                    this.setDelayedModal();
                }
            }
        },
        checkDelayedModal() {
            const modalName = window.localStorage.getItem(this.storageKey);
            if (modalName === this.cookie) {
                setTimeout(async () => await this.tryOpenModal(), 5000);
            }
        },
        setDelayedModal() {
            window.localStorage.setItem(this.storageKey, this.cookie);
        },
        removeDelayedModal() {
            const modalName = window.localStorage.getItem(this.storageKey);
            if (modalName === this.cookie) {
                window.localStorage.removeItem(this.storageKey);
            }
        },
        temporaryDisableModals() {
            const date = new Date();
            date.setTime(date.getTime() + this.temporaryDisableTimeout * 1000);
            Cookies.set(this.cookieKey, true, {expires: date});
        },
        isModalTemporaryDisabled() {
            return Cookies.get(this.cookieKey);
        },
        _subscribeStore() {
            store.subscribe((mutation, _state) => {
                if (mutation.type === 'timerTimeout' && mutation.payload === this.timeoutSec) {
                    this.tryOpenModal();
                }
            });
        },
        async initialize() {
            const cookie = await Cookies.getWithBackupCheckAsync(this.cookie);
            if (!cookie) {
                this.checkDelayedModal();
                this._subscribeStore();
            }
        },
    },
    async mounted() {
        await this.initialize();
    },
};

const engageModal = {
    mixins: [baseEngageModal],
    data() {
        return {
            cookieCheckTime: 5,
            idleTimeoutInSeconds: 30,
            pageSpentTimeOnPreviousTick: 0,
        };
    },
    props: {
        forceSimpleTimer: {
            type: Boolean,
        },
        closeText: {
            type: String,
        },
    },
    methods: {
        open() {
            return this.defaultOpen();
        },
        close(data) {
            this.defaultClose(data);
        },
        async tryOpenModal() {
            this.open();

            if (this.forceSimpleTimer && this.cookie && !(await this.isCookieSet())) {
                if (this.active) {
                    await Cookies.setWithBackupAsync(this.cookie, this.timeoutSec, {expires: this.cookieExpiration});
                } else {
                    this.startSimpleTimer(this.cookieCheckTime); // reset timer if another modal is opened
                }
            }
        },
        startSimpleTimer(timeoutSec) {
            setTimeout(async () => {
                await this.tryOpenModal();
            }, timeoutSec * 1000);
        },
        async startCookieTimer() {
            this.previousSpentTime = await this.getPreviousSpentTime();
            if (this.previousSpentTime < this.timeoutSec) {
                TimeMe.initialize({
                    currentPageName: this.cookie,
                    idleTimeoutInSeconds: this.idleTimeoutInSeconds,
                });

                TimeMe.callAfterTimeElapsedInSeconds(this.cookieCheckTime, this.measureSpentTime);
            }
        },
        resetCookieTimer() {
            TimeMe.resetRecordedPageTime(this.cookie);
            Cookies.setWithBackupAsync(this.cookie, this.previousSpentTime || 0, {expires: this.cookieExpiration});
            TimeMe.callAfterTimeElapsedInSeconds(this.cookieCheckTime, this.measureSpentTime);
        },
        async getPreviousSpentTime() {
            if (!this.cookie) {
                return 0;
            }

            const radix = 10;
            const value = parseInt(await Cookies.getWithBackupCheckAsync(this.cookie), radix);
            return isNaN(value) ? 0 : value;
        },
        async measureSpentTime() {
            const pageSpentTime = TimeMe.getTimeOnCurrentPageInSeconds();
            const summarySpentTime = await this.getPreviousSpentTime() + pageSpentTime - this.pageSpentTimeOnPreviousTick;
            await Cookies.setWithBackupAsync(this.cookie, summarySpentTime, {expires: this.cookieExpiration});

            if (summarySpentTime >= this.timeoutSec) {
                this.open();

                if (!this.active) {
                    this.resetCookieTimer(); // reset timer if another modal is opened
                }
            } else {
                this.pageSpentTimeOnPreviousTick = pageSpentTime;
                TimeMe.callAfterTimeElapsedInSeconds(pageSpentTime + this.cookieCheckTime, this.measureSpentTime);
            }
        },
        async initTimer() {
            if (this.timeoutSec > 0) {
                if (this.cookie && !this.forceSimpleTimer) {
                    await this.startCookieTimer();
                } else {
                    const alreadyDone = this.forceSimpleTimer && await Cookies.getWithBackupCheckAsync(this.cookie) != null;

                    if (!alreadyDone) {
                        this.startSimpleTimer(this.timeoutSec);
                    }
                }
            }
        },
        async isCookieSet() {
            return await Cookies.getWithBackupCheckAsync(this.cookie) != null;
        },
        _subscribeStore() {
            store.subscribe((mutation) => {
                this.isCookieSet().then((isCookieSetValue) => {
                    if (!isCookieSetValue && mutation.type === 'preventShowingEngage' && mutation.payload === this.cookie) {
                        Cookies.set(this.cookie, this.timeoutSec, {expires: this.cookieExpiration});
                    }
                });
            });
        },
    },
    async mounted() {
        this._subscribeStore();
        await this.initTimer();
    },
};

const reviewEvaluation = {
    default: 'default',
    positive: 'positive',
    negative: 'negative',
};

const sendFeedbackMixin = {
    props: {
        infoModalContent: {
            type: Object,
            required: true,
        },
        antiforgeryToken: {
            type: String,
            required: true,
        },
        submitUrl: {
            type: String,
            required: true,
        },
        currentUrl: {
            type: String,
            required: true,
        },
        feedbackType: {
            type: Number,
            default: 2,
        },
    },
    methods: {
        _createDescription() {
            // override this method to create feedback description
            return '';
        },

        send() {
            const requestConfig = _u.createRequestConfig(this.antiforgeryToken);

            const requestBody = {
                description: this._createDescription(),
                url: this.currentUrl,
                makeScreenshot: false,
                type: this.feedbackType,
            };

            axios.post(this.submitUrl, requestBody, requestConfig)
                .then(() => {
                    this._openInfoModal(true);
                })
                .catch(() => {
                    this._openInfoModal(false);
                });
        },
        _openInfoModal(isSuccess = true) {
            this.close();
            globalActions.openInfoModal(this._getInfoModalHeader(isSuccess), this._getInfoModalBody(isSuccess));
        },
        _getInfoModalBody(isSuccess) {
            return isSuccess ? this.infoModalContent.body.positive : this.infoModalContent.body.negative;
        },
        _getInfoModalHeader(isSuccess) {
            return isSuccess ? this.infoModalContent.header.positive : this.infoModalContent.header.negative;
        },
    },
};

const globalOpenModalMixin = {
    data: () => ({
        openAction: '',
    }),
    mounted() {
        store.subscribe((mutation) => {
            if (mutation.type === this.openAction) {
                this.open();
            }
        });
    },
};

const deleteRequestModalMixin = {
    props: {
        isRevertRequired: {type: Boolean},
        submitDeleteRequestUrl: {type: String},
        cancelDeleteRequestUrl: {type: String},
    },
    data() {
        return {
            id: _u.genUid(),
            agreeToDelete: this.isRevertRequired,
        };
    },
    computed: {
        isSubmitDisabled() {
            return !this.agreeToDelete || (!this.isRevertRequired && this.confirmText !== this.confirmTextEntered);
        },
    },
    methods: {
        _subscribeModalConfirmActions() {
            const cancelModalSelector = this.$el.querySelector('.word-unclaim-deleting .modal');
            const confirmModalSelector = this.$el.querySelector('.word-confirm-deleting .modal');

            _u.subscribeModalConfirm([`#${this.id} .js-unclaim-deleting-request`], cancelModalSelector);
            _u.subscribeModalConfirm([`#${this.id} .js-submit-deleting-request`], confirmModalSelector);

            const actions = [`#${this.id} .js-submit-deleting-request`, `#${this.id} .js-unclaim-deleting-request`];
            for (const action of actions) {
                _u.confirmAction[action]($(action),
                    (target) => {
                        target.form.action = target.formAction;
                        target.form.submit();
                    });
            }
        },
        _subscribeModalCloseActions() {
            _u.subscribeModalClose(`#${this.id} .word-unclaim-deleting #close-modal`, `#${this.id} .word-unclaim-deleting .modal`);
            _u.subscribeModalClose(`#${this.id} .word-confirm-deleting #close-modal`, `#${this.id} .word-confirm-deleting .modal`);
        },
    },
    mounted() {
        this._subscribeModalConfirmActions();
        this._subscribeModalCloseActions();
    },
};

const modalAdvertDelete = {
    extends: deleteModal,
    template: modalWithConfirmationTemplateName,
    data() {
        return {
            deleteUrl: '',
        };
    },
    methods: {
        accept() {
            this._sendRequest(this.deleteUrl);
            this.clearModal();
            this.close();
        },
        successfullySent(response) {
            window.location = response;
        },
        _subscribeOpen() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openDeleteModal') {
                    this.active = true;
                    this.deleteUrl = mutation.payload.url;
                }
            });
        },
    },
    mounted() {
        this._subscribeOpen();
    },
};

const modalAdvertReport = {
    extends: reportModal,
    template: modalWithConfirmationTemplateName,
    data() {
        return {
            listingType: null,
        };
    },
    methods: {
        initializeReportModalData(payload) {
            this.active = true;
            this.targetId = payload.targetId;
            this.listingType = payload.listingType;
        },
        getRequestBody() {
            return {
                targetId: this.targetId,
                reason: this.selectedReason.value,
                reasonMessage: this.selectedReasonMessage,
                listingType: this.listingType,
            };
        },
    },
};

const modalFullscreen = {
    extends: modal,
    template: '#modal-fullscreen',
    props: {
        autoClose: {
            type: Boolean,
            default: true,
        },
        position: {
            type: String,
            default: 'right',
        },
        positionWidth: {
            type: String,
            default: null,
        },
        background: {
            type: String,
            default: 'gradient',
        },
        backgroundInverse: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: String,
            default: 'dark',
        },
        hasNext: Boolean,
        hasPrev: Boolean,
        hasClose: {
            type: Boolean,
            default: true,
        },
        hasLogo: Boolean,
        noTransition: {
            type: Boolean,
            default: false,
        },
        updateBrowserHistory: {
            type: Boolean,
            default: true,
        },
        previewUrl: {
            type: String,
        },
        hasChat: {
            type: Boolean,
            default: false,
        },
        previewPayload: {
            type: Object,
            required: false,
        },
        hideChatIcon: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            pushedUrls: [],
        };
    },

    watch: {
        previewUrl: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!this.updateBrowserHistory) {
                    return;
                }

                this._updateBrowserHistory(this.isActive ? newValue : null, oldValue);
            },
        },
        isActive: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!this.updateBrowserHistory) {
                    return;
                }

                if (newValue && !oldValue) {
                    // modal opened
                    this._subscribeUrlChange();
                } else if (!newValue && oldValue) {
                    // modal closed
                    this._unsubscribeUrlChange();
                }

                this._updateBrowserHistory(newValue ? this.previewUrl : null);
            },
        },

        hideChatIcon: {
            immediate: true,
            handler(val) {
                globalActions.changePreviewChatIconVisibility(val);
            },
        },
    },

    computed: {
        forcePushToHistory() {
            return this.hasNext || this.hasPrev;
        },

        unreadMessagesCount() {
            return store.state.shared.unreadMessagesCount;
        },

        hidePreviewChatIcon() {
            return store.state.shared.hidePreviewChatIcon;
        },
    },

    methods: {
        openChat() {
            this.$emit('close');
            store.commit('openChat', this.previewPayload);
        },

        next() {
            this.$emit('next');
        },

        prev() {
            this.$emit('prev');
        },

        isUrlPushedToHistory() {
            return this.pushedUrls.length > 0;
        },

        _updateBrowserHistory(newUrl, oldUrl) {
            if (newUrl != null) {
                this._addUrlToBrowserHistory(newUrl, oldUrl);
            }
        },

        _addUrlToBrowserHistory(newUrl, oldUrl) {
            const currentUrl = this._getCurrentUrl();

            if (newUrl !== currentUrl && newUrl !== oldUrl && newUrl) {
                if (!this.isUrlPushedToHistory() || this.forcePushToHistory) {
                    window.history.pushState({}, null, newUrl);
                    this._savePushedUrl(newUrl);
                } else {
                    window.history.replaceState({}, null, newUrl);
                    this._replacePushedUrl(newUrl);
                }
            }

            if (newUrl === currentUrl && !this._isUrlSaved(newUrl)) {
                this._savePushedUrl(newUrl);
            }
        },

        _isUrlSaved(url) {
            return this.pushedUrls.some((pushedUrl) => pushedUrl === url);
        },

        _savePushedUrl(url) {
            this.pushedUrls.push(url);
        },

        _removeLastPushedUrl() {
            this.pushedUrls.pop();
        },

        _getLastPushedUrl() {
            return this.pushedUrls.length > 0 ? this.pushedUrls[this.pushedUrls.length - 1] : null;
        },

        _clearPushedUrls() {
            this.pushedUrls = [];
        },

        _replacePushedUrl(url) {
            this.pushedUrls[this.pushedUrls.length - 1] = url;
        },

        _getCurrentUrl() {
            return location.pathname + location.search + location.hash;
        },

        _handleBrowserNavigation() {
            // back/forward case
            if (this.isUrlPushedToHistory()) {
                this._removeLastPushedUrl();
            }

            if (this.isActive && (!this.isUrlPushedToHistory() || !this._isUrlSaved(this._getCurrentUrl()))) {
                this.close({closeOnBack: true});
            }
        },

        _subscribeUrlChange() {
            if (!this.updateBrowserHistory) {
                return;
            }

            window.addEventListener('popstate', this._handleBrowserNavigation);
        },

        _unsubscribeUrlChange() {
            if (!this.updateBrowserHistory) {
                return;
            }

            window.removeEventListener('popstate', this._handleBrowserNavigation);
        },
    },
};

const viewedAdvertModal = {
    extends: modal,
    template: modalQuestionTemplateName,
    props: {
        addToFavoritesUrl: {},
        removeFromFavoritesUrl: {},
    },
    mixins: [engageModal, questionModal],
    data() {
        return {
            openOnlyIfTargetVisible: false,
            isRequestCompleted: false,
            shouldBeOpened: true,
            requestCheckTime: 1,
        };
    },
    methods: {
        accept() {
            this.close();
        },
        cancel() {
            axios.post(this.removeFromFavoritesUrl)
                .catch(globalActions.handleAjaxErrors);

            this.close();
        },
        tryAddToFavorites() {
            axios.post(this.addToFavoritesUrl)
                .then((result) => {
                    if (!result.data) {
                        this.shouldBeOpened = false;
                    }
                    this.completeRequest();
                })
                .catch((result) => {
                    this.completeRequest();
                    globalActions.handleAjaxErrors(result.response);
                });
        },
        completeRequest() {
            this.isRequestCompleted = true;
        },
        startSimpleTimer(timeoutSec) {
            setTimeout(() => {
                if (this.shouldBeOpened) {
                    if (this.isRequestCompleted) {
                        this.tryOpenModal();
                    } else {
                        this.startSimpleTimer(this.requestCheckTime);
                    }
                }
            }, timeoutSec * 1000);
        },
    },
    mounted() {
        this.isCookieSet().then((isCookieSetValue) => {
            if (!isCookieSetValue) {
                this.tryAddToFavorites();
            }
        });
    },
};

const actionEngageModal = {
    extends: modal,
    template: '#action-engage-modal',
    mixins: [engageModal],
    props: {
        autoClose: {
            type: Boolean,
            default: true,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
        },
    },
    data() {
        return {
            scrollToTarget: true,
        };
    },
    methods: {
        onAction() {
            if (this.autoClose) {
                this.close();
            }
        },
    },
};

const engagePopupModal = {
    extends: modal,
    template: '#engage-popup-modal',
    mixins: [engageModal],
    data() {
        return {
            openOnlyIfTargetVisible: false,
        };
    },
    props: {
        footerText: {
            type: String,
        },
        engageAction: {
            type: String,
            required: true,
        },
        actionText: {
            type: String,
            required: true,
        },
        url: {
            type: String,
        },
    },
    methods: {
        onActionButtonClick() {
            this.close();
            if (this.url) {
                window.location = this.url;
            }
        },
    },
};

const engageRateUsModal = {
    extends: modal,
    template: '#engage-rateus-modal',
    mixins: [timerBasedModal, sendFeedbackMixin],
    data() {
        return {
            openOnlyIfTargetVisible: false,
            evaluation: reviewEvaluation.default,
            rating: 0,
            feedback: '',
        };
    },
    props: {
        headerContent: {
            type: Object,
            required: true,
        },
        bodyContent: {
            type: Object,
            required: true,
        },
        buttonContent: {
            type: Object,
            required: true,
        },
        reviewUrl: {
            type: String,
            required: true,
        },
        longCookieExpiration: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isPositiveReview() {
            return this.rating > 3;
        },
        isNegativeReview() {
            return this.rating > 0 && this.rating < 4;
        },
    },
    watch: {
        rating() {
            if (this.isPositiveReview) {
                this.evaluation = reviewEvaluation.positive;
            } else if (this.isNegativeReview) {
                this.evaluation = reviewEvaluation.negative;
            } else {
                this.evaluation = reviewEvaluation.default;
            }
        },
    },
    methods: {
        onActionButtonClick() {
            this.evaluation === reviewEvaluation.positive ?
                this.review() :
                this.sendFeedback();
        },
        review() {
            this.setCookie(this.longCookieExpiration[this.evaluation]);
            this.close();
            window.open(this.reviewUrl, '_blank');
        },
        createDescription() {
            return `Rate: ${this.rating} \n\n**Feedback:**  \n${this.feedback}`;
        },
        sendFeedback() {
            this.setCookie(this.longCookieExpiration[this.evaluation]);
            this.send();
        },
        setCookie(expiration) {
            Cookies.setWithBackupAsync(this.cookie, true, {expires: expiration});
        },
    },
};

const infoModal = {
    template: '#info-modal',
    computed: {
        active: {
            get() {
                return store.state.shared.infoModal.active;
            },

            set() {
                this.closeModal();
            },
        },
        title() {
            return store.state.shared.infoModal.title;
        },
        message() {
            return store.state.shared.infoModal.message;
        },
        trackCategory() {
            return store.state.shared.infoModal.trackCategory;
        },
        trackAction() {
            return store.state.shared.infoModal.trackAction;
        },
        modalId() {
            return store.state.shared.infoModal.modalId;
        },
    },
    methods: {
        closeModal() {
            store.commit('closeInfoModal');
        },
    },
};

const loadingModal = {
    template: '#loading-modal',
    extends: modal,
};

const regionalSettingsModal = {
    template: '#regional-settings-modal',
    data() {
        return {
            active: false,
            selectedCurrency: null,
            selectedMeasurement: null,
            selectedLanguage: null,
        };
    },
    methods: {
        close() {
            this.active = false;
        },
        saveSettings(url) {
            const data = {
                preferredCurrency: this.selectedCurrency.isoCurrencySymbol,
                preferredMeasurement: this.selectedMeasurement.value,
                preferredLanguage: this.selectedLanguage.label,
            };
            axios.post(url, data)
                .then(() => location.reload())
                .catch(globalActions.handleAjaxErrors);
        },
        _subscribeOpen() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openRegionalSettings') {
                    this.active = true;
                }
            });
        },
    },
    mounted() {
        this._subscribeOpen();
    },
};

const selectRegionModal = {
    extends: modal,
    template: '#select-region-modal',
    mixins: [sendFeedbackMixin],
    props: {
        isMobileApp: {
            type: Boolean,
            default: false,
        },
        isCommercialAvailable: {
            type: Boolean,
            default: false,
        },
        locale: {
            type: String,
            default: 'en',
        },
        regions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedRegion: null,
            isCommercial: null,
            isRegionSelection: true,
            selectedCountry: null,
            countries: [],
        };
    },
    computed: {
        isCountriesLoaded() {
            return this.countries.length > 0;
        },
    },
    methods: {
        discardSelection() {
            this.isRegionSelection = true;
            this.selectedCountry = null;
        },
        changeSelectionMode() {
            this.isRegionSelection = !this.isRegionSelection;
            this.selectedCountry = null;
        },
        select() {
            this.isRegionSelection ? this._redirect() : this.send();
        },
        _redirect() {
            const link = this.isCommercial ?
                this.selectedRegion.commercialLink :
                this.selectedRegion.link;

            if (window.location.origin === link) {
                this.close();
            } else {
                if (this.isMobileApp) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({region: this.selectedRegion.countryCode}));
                    window.location.replace(link);
                } else {
                    window.location.href = link;
                }
            }
        },
        _createDescription() {
            return `User try choose country: ${this.selectedCountry.code} - ${this.selectedCountry.name}`;
        },
        _getInfoModalBody(isSuccess) {
            return isSuccess ? `${this.infoModalContent.success.body} ${this.selectedCountry.name}` : this.infoModalContent.fail.body;
        },
        _getInfoModalHeader(isSuccess) {
            return isSuccess ? this.infoModalContent.success.header : this.infoModalContent.fail.header;
        },
        _getCountries() {
            const countries = getCountries(this.locale);
            const countryCodes = this.regions.map((region) => region.countryCode);
            this.countries = countries.filter((country) => !countryCodes.includes(country.code.toLowerCase()));
        },
        _subscribeOpen() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openRegionSelectModal') {
                    this.open();
                }
            });
        },
    },
    mounted() {
        this._subscribeOpen();
        this._getCountries();
    },
};

const globalFullscreenModal = {
    template: '#global-fullscreen-modal',
    props: {
        isMobileDevice: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        state() {
            return store.state.shared.fullscreenModalData || {};
        },
        previewUrl() {
            return store.state.shared.fullscreenModalUrl;
        },
        previewSrc: {
            get() {
                return store.state.shared.fullscreenModalSrc;
            },
            set(value) {
                if (value === null) {
                    store.commit('closeFullscreenModal');

                    if (this.isMobileDevice) {
                        globalActions.showFeedbackButton();
                    }
                } else {
                    store.commit('openFullscreenModal', value);
                }
            },
        },
    },
    methods: {
        closeModal() {
            this.resetPageUrl();
            this.previewSrc = null;
        },
        preview(url) {
            this.previewSrc = url;
        },
        resetPageUrl() {
            if (this.state.title !== undefined && this.state.currentPage !== undefined) {
                document.title = this.state.title;
                window.history.replaceState(window.location.state, this.state.title, this.state.currentPage);
            }
        },
    },
};

function initModalsComponent(app) {
    app.component('modal', {
        extends: modal,
        template: '#modal',
    });

    app.component('modal-question', {
        extends: modal,
        template: modalQuestionTemplateName,
        mixins: [questionModal],
    });

    app.component('modal-profile-delete', {
        extends: deleteModal,
        template: modalWithConfirmationTemplateName,
        methods: {
            successfullySent() {
                this.$emit('delete', true);
            },
        },
    });

    app.component('modal-advert-delete', modalAdvertDelete);

    app.component('modal-comment-report', {
        extends: reportModal,
        template: modalWithConfirmationTemplateName,
    });

    app.component('modal-advert-report', modalAdvertReport);

    app.component('modal-cancel-wizard-report', {
        extends: reportModal,
        props: {
            redirectUrl: {},
        },
        methods: {
            successfullySent() {
            },
        },
    });

    app.component('modal-conversation-report', {
        extends: reportModal,
        template: modalWithConfirmationTemplateName,
        methods: {
            successfullySent() {
                globalActions.submitReportModal({reportType: this.reportType});
                globalActions.openInfoModal(this.labels.successHeader, this.labels.successMessage);
            },
        },
    });

    app.component('modal-fullscreen', modalFullscreen);
    app.component('viewed-advert-modal', viewedAdvertModal);
    app.component('action-engage-modal', actionEngageModal);
    app.component('engage-popup-modal', engagePopupModal);
    app.component('engage-rateus-modal', engageRateUsModal);

    app.component('engage-zoho-modal', {
        extends: modal,
        template: '#engage-zoho-modal',
        mixins: [timerBasedModal],
        data() {
            return {
                openOnlyIfTargetVisible: false,
            };
        },
    });

    app.component('engage-register-modal', {
        extends: modal,
        template: '#modal',
        methods: {
            onActionButtonClick() {
                this.close();
                globalActions.openRegisterModal();
            },
        },
    });

    app.component('info-modal', infoModal);
    app.component('loading-modal', loadingModal);
    app.component('regional-settings-modal', regionalSettingsModal);
    app.component('select-region-modal', selectRegionModal);
    app.component('global-fullscreen-modal', globalFullscreenModal);

    app.component('delete-profile-request-modal', {
        template: '#delete-profile-request-modal-template',
        mixins: [userModalMixin, deleteRequestModalMixin],
    });

    app.component('delete-advert-request-modal', {
        template: '#delete-advert-request-modal-template',
        mixins: [userModalMixin, deleteRequestModalMixin],
        props: {
            isRequest: {type: Boolean},
        },
    });

    app.component('limit-info-modal', {
        extends: modal,
        template: '#limit-info-modal',
        props: {
            isUserAuthenticated: {type: Boolean},
        },
        methods: {
            register() {
                this.close();
                globalActions.openLoginModal();
            },
            _subscribeOpenModal() {
                store.subscribe((mutation) => {
                    if (mutation.type === 'openLimitInfoModal') {
                        nextTick(() => {
                            this.open();
                        });
                    }
                });
            },
        },

        mounted() {
            this._subscribeOpenModal();
        },
    });
}

const isAnyModalOpened = () => {
    if (store.state.shared.preventShowingModals) { // do not show if modals are locked
        return true;
    }

    if (store.state.shared.engagesCount > 0) { // do not show multiple engages
        return true;
    }

    if (store.state.shared.activeInputCount > 0) { // do not show if any textarea is focused
        return true;
    }

    return store.state.shared.openedDropdown; // do not show if any dropdown is opened
};

export {
    initModalsComponent,
    isAnyModalOpened,
    modal,
    questionModal,
};
